import { Icon } from "orcs-design-system";

import {
  EFFECT_LABEL,
  type Effect,
} from "src/pages/WorkforceGuardrails/ruleShape";

export type IconVariant =
  | "primary"
  | "secondary"
  | "success"
  | "warning"
  | "danger"
  | "grey";

/** String form is `far`. Use `fas` when that is the registered inventory prefix. */
export type SeverityIconName = string | [string, string];

export const severityOf = (
  effect: Effect | null
): { icon: SeverityIconName; variant: IconVariant; label: string } => {
  switch (effect) {
    case "BLOCK":
      return {
        icon: "circle-xmark",
        variant: "danger",
        label: EFFECT_LABEL.BLOCK,
      };
    case "WARN":
      return {
        icon: "exclamation-triangle",
        variant: "warning",
        label: EFFECT_LABEL.WARN,
      };
    case "ADD_APPROVAL_STEP":
      return {
        icon: "user-plus",
        variant: "primary",
        label: EFFECT_LABEL.ADD_APPROVAL_STEP,
      };
    case "SKIP_APPROVAL_STEP":
      return {
        icon: ["fas", "user-minus"],
        variant: "secondary",
        label: EFFECT_LABEL.SKIP_APPROVAL_STEP,
      };
    case "AUTO_APPROVE":
      return {
        icon: ["fas", "bolt"],
        variant: "success",
        label: EFFECT_LABEL.AUTO_APPROVE,
      };
    case null:
      return {
        icon: ["fas", "ban"],
        variant: "grey",
        label: "Retired",
      };
    default: {
      const unexpected: never = effect;
      return unexpected;
    }
  }
};

export const GuardrailSeverityIcon = ({
  effect,
}: {
  effect: Effect | null;
}) => {
  const { icon, variant, label } = severityOf(effect);
  return (
    <Icon
      icon={icon}
      variant={variant}
      fixedWidth
      role="img"
      aria-label={label}
      title={label}
    />
  );
};
